module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "width-wrapper relative"
  }, [_c('nav', {
    staticClass: "top-nav"
  }, [_c('a', {
    staticClass: "top-nav__link",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/pharmacies/')
      }
    }
  }, [_vm._v("Аптеки")]), _vm._v(" "), (_vm.user.role == 'HM') ? _c('a', {
    staticClass: "top-nav__link",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/products/')
      }
    }
  }, [_vm._v("Товары")]) : _vm._e(), _vm._v(" "), (_vm.user.role == 'HM') ? _c('a', {
    staticClass: "top-nav__link",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/reports/')
      }
    }
  }, [_vm._v("Отчеты и отправка")]) : _vm._e(), _vm._v(" "), (_vm.user.role == 'HM') ? _c('a', {
    staticClass: "top-nav__link",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/users/')
      }
    }
  }, [_vm._v("Сотрудники")]) : _vm._e()]), _vm._v(" "), (_vm.$auth.ready()) ? _c('div', {
    staticClass: "user-info"
  }, [_c('a', {
    staticClass: "header-notificatons",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [_vm._v(_vm._s(_vm.user.email) + "\n          "), _c('a', {
    staticClass: "logout_link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$auth.logout();
        _vm.$router.replace({
          path: '/login'
        });
      }
    }
  }, [_vm._v("Выйти")])])]) : _vm._e()])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 254
// module chunks = 1